
(function() {
	var s = document.createElement('script');
	s.id = 'LeadiDscript_campaign';
	s.type = 'text/javascript';
	s.async = true;
	s.src = '//create.lidstatic.com/campaign/07d08efd-b67b-e5f2-8ee0-fb028040e3ff.js?snippet_version=2';
	var LeadiDscript = document.getElementById('lidoScript');
	LeadiDscript.parentNode.insertBefore(s, LeadiDscript);
	})();
